module.exports = __webpack_public_path__ + "static/media/211CS130.6607efcc.jpg";